import { render, staticRenderFns } from "./ContainerShowForm.vue?vue&type=template&id=504b8fbc&"
import script from "./ContainerShowForm.vue?vue&type=script&lang=js&"
export * from "./ContainerShowForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports